import { matchPath } from 'react-router';
import { buildSortFilterSearchQuery, parseSortFiltersSearchQuery, SortFiltersParams } from './sortFiltersParams';
import { createRoute } from './createRoute';
import { generatePath } from './generatePath';

export interface MicroCategoryPageParams extends SortFiltersParams {
  page: number;
  microCategorySlug: string;
}

export interface MicroCategoryPage {
  routeName: 'microCategory';
  params: MicroCategoryPageParams;
}

export const microCategoryRoute = createRoute<MicroCategoryPageParams, 'microCategorySlug'>({
  pattern: '/refine/:microCategorySlug/:page?',
  build: (pattern, params) => {
    const { page, microCategorySlug } = params;

    const pathParams = {
      page: page == null || page === 1 ? null : String(page),
      microCategorySlug: (microCategorySlug || '').toLowerCase(),
    };

    const searchQuery = buildSortFilterSearchQuery(params);
    return {
      pathname: generatePath(pattern, pathParams),
      search: searchQuery,
    };
  },
  match: (pattern, location) => {
    const { pathname, search } = location;
    const match = matchPath({ path: pattern }, pathname);

    if (!match) {
      return null;
    }

    // See categoryRoute: re-validate the now-unconstrained `:page?` segment.
    const { page } = match.params;
    if (page !== undefined && !/^\d+$/.test(page)) {
      return null;
    }

    const requestedPage = Number(page);
    return {
      ...parseSortFiltersSearchQuery(search),
      microCategorySlug: decodeURIComponent(match.params.microCategorySlug ?? ''),
      page: requestedPage || 1,
    };
  },
});
